<template>
    <div class="valentines">
        <p>ENFIN !! Tu dois te dire 😊<br>
            Mais les preuves d’amour comme ça, ça ne s’improvise pas, il faut avoir des choses à
            dire.<br>
            Et il se trouve que j’ai des choses à te dire !
        </p>
        <p>En effet, les jours passent, les mois passent, même les années. Cependant, pas une
            seconde ne s’écoule sans que j’ai envie de partager une peu plus ma vie avec toi ❤<br>
            Cela fait longtemps qu’on en parle, longtemps qu’on espère…<br>
            Je sais qu’un jour tous nous rêves vont se réaliser 🙂<br>
            Nous avons juste besoin d’un peu de patience… Après tout, je ne pense pas que l’un ou
            l’autre s’envole 😊!
        </p>
        <p>Enfin bref, j’ai bon espoir que nous emménagions ensemble, afin de faire notre petite vie
            tranquille, sans avoir personne sur notre dos (😉)<br>
            Beaucoup de choses vont se mettre en place et j’ai déjà hâte !
        </p>
        <ul>
            <li>Le sport</li>
            <li>L’alimentation</li>
            <li>Plus d’aller-retours</li>
            <li>Chaque nuit ensemble</li>
            <li>Des séries à gogo</li>
        </ul>
        <p></p>
        <p>Je suis extrêmement enthousiaste à l’idée de partager concrètement ma vie avec toi ❤</p>
        <p>Je me sens de plus en plus adulte, et je le ressens aussi pour toi.<br>
            J’ai pu voir une très belle évolution, de fille timide et pas sure d’elle, à une belle
            femme, qui assume ses choix, s’impose un peu plus et, il faut le dire, à son caractère
            🙂<br>
            Tu prends en main ta vie (ou aimerais le faire #classeur), tu trouves du travail, tu as
            ton permis, des collègues, etc.<br>
            Il faut dire que j’ai un peu de retard sur certains points 😊
        </p>
        <p>Ça ne m’empêche pas d’admirer ton évolution et ton enthousiasme dans le domaine que tu as
            choisi pour ton travail.<br>
            Tu apprends vite et je te vois extrêmement impliquée. Non seulement tu sais maintenant
            coder, mais en plus tu partages ce savoir !<br>
            Plus d’une fois, je pensais t’apprendre quelque chose … que tu connaissais déjà !<br>
            Je vois vraiment ton intérêt pour de nouvelles choses : tu lis des posts de blogs, des
            articles sur des sujets et même de l’actualité. Ça fait vraiment plaisir à voir 🙂
        </p>
        <p>Je sais que tu vas encore trouver ça trop court mais je me suis livré 😊<br>
            J’espère que nous avons encore de longues années devant nous et si chacun de nous évolue
            autant que l’on l’a fait actuellement, je ne peux qu’imagine de beaux jours.<br>
            J’espère que notre soirée sera romantique, et que notre passage à la crêperie (si on y
            va toujours) sera très agréable. C’est le genre de choses que l’on va pouvoir se
            permettre plus qu’avant et j’en suis très heureux !<br>
            J’espère aussi que nous pourrons participer à certaines nouvelles activités pour
            s’occuper et découvrir de nouvelles choses !
        </p>
        <p>Sur ce, je te souhaite, ma <strong>Valentine</strong>, une très joyeuse Saint-Valentin.
        </p>
        <p style="text-align: center">Amoureusement, Quentin ❤</p>

        <div>
            <iframe
                    class="mt-5 iframe"
                    src="https://www.script-tutorials.com/demos/234/ex5.html"
                    frameborder="0"
                    scrolling="no"
                    width="100%"
                    height="500"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
  name: 'MyValentine',
};
</script>

<style scoped>
    .valentines {
        text-align: left;
    }
</style>
